import React, {Component} from 'react';
import "./luiss_map_marker.scss";


export interface LuissMapMarkerData {
    lat: number;
    lng: number;
    onMarkerClick: () => void;
}

class LuissMapMarker extends Component<LuissMapMarkerData> {
    render() {
        return (
            <img className="luiss-map-marker" src="/marker.png" alt="" onClick={() => this.props.onMarkerClick()} />
        );
    }
}

export default LuissMapMarker;
